import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "content-select-top-area" }
const _hoisted_3 = { class: "content-info" }
const _hoisted_4 = { class: "content-title" }
const _hoisted_5 = { class: "content-date" }
const _hoisted_6 = {
  key: 0,
  class: "content-buttons"
}
const _hoisted_7 = { class: "content-buttons-left" }
const _hoisted_8 = { class: "content-buttons-right" }
const _hoisted_9 = { class: "like-button detail-button" }
const _hoisted_10 = ["checked"]
const _hoisted_11 = ["checked"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "content-info-footer" }
const _hoisted_14 = { class: "content-tags" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 0,
  class: "content-footer-buttons"
}
const _hoisted_18 = { class: "like-button detail-button" }
const _hoisted_19 = ["checked"]
const _hoisted_20 = ["checked"]
const _hoisted_21 = {
  key: 0,
  class: "content-other"
}
const _hoisted_22 = { class: "content-other-text" }
const _hoisted_23 = { class: "content-other-buttons" }
const _hoisted_24 = {
  key: 0,
  class: "other-contents"
}
const _hoisted_25 = {
  key: 0,
  class: "other-contents-items"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["src", "alt"]
const _hoisted_28 = { class: "sp-wrapper-right" }
const _hoisted_29 = { class: "content-item-title" }
const _hoisted_30 = { class: "tag-container" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "sp-wrapper-bottom" }
const _hoisted_36 = { class: "content-item-date" }
const _hoisted_37 = { class: "content-item-writer" }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { class: "writer-name-area" }
const _hoisted_40 = { class: "like-button" }
const _hoisted_41 = ["id", "checked", "onChange"]
const _hoisted_42 = ["for"]
const _hoisted_43 = ["id", "checked", "onChange"]
const _hoisted_44 = ["for"]
const _hoisted_45 = {
  key: 1,
  class: "other-contents-button"
}
const _hoisted_46 = {
  key: 1,
  class: "content-recs"
}
const _hoisted_47 = { class: "content-recs-text" }

import { ref, onMounted, computed, reactive } from "vue";
import { useRoute, useRouter } from "vue-router";
import { Content } from "@/models/contents/content";
import { UserArticleLike } from "@/models/users/articleLikes";
import { UserAuthorFollow } from "@/models/users/authorFollow";
import { UserArticleFavorite } from "@/models/users/articleFavorite";
import { NoticeList } from "@/models/notice/noticeList";
import Header from "@/components/modules/base/Header.vue";
import Footer from "@/components/modules/base/Footer.vue";
import { processing, processend } from "@/utils/view";
import ErrorDialog from "@/views/base/CommonMessage.vue";
import { _$t } from "@/utils/i18n";
// ---- Interfaces -------------------------------------------------
interface ContentDetailData {
  articleId: number;
  title: string;
  contentType: number;
  coverPhotoUrl: string;
  dateFirstPublished: string | null;
  poster: {
    adminId: number;
    nickname: string;
  };
  diseases: {
    diseaseCode: string;
    diseaseName: string;
  }[];
  tags: {
    tagId: number;
    tagName: string;
  }[];
  isFavorite: boolean;
  isFollowed: boolean;
  isLiked: boolean;
  isNew: boolean;
  likeCount: number;
  html: string;
}

interface ArticleQueryCond {
  diseaseCodes?: string[];
  tagIds?: number[];
  posterIds?: number[];
}

// ---- Constants ----------------------------------------------
const componentId = "generalpurpose06-05";
const activeMenu = "article";
const page = 1;
const size = 4;

export default /*@__PURE__*/_defineComponent({
  __name: 'detail',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const articleId = ref(Number(route.params.articleId));
const isNotice = ref(route.path.includes("/notice/"));
const content = new Content();
const userAuthorFollow = new UserAuthorFollow();
const userArticleLike = new UserArticleLike();
const userArticleFavorite = new UserArticleFavorite();
const contentDetail = ref<ContentDetailData | null>(null);
const relatedContents = ref<ContentDetailData[]>([]);
const expandedItems = reactive<{ [key: string]: boolean }>({});
const tagListRefs = reactive({});

const contentCond = computed(() => ({
  posterIds: [contentDetail.value?.poster.adminId],
}));

// セッションエラーチェック
let sessionErr = ref(false);
let errorDialog = reactive({
  show: false,
  okButtonHide: true,
  safe: false,
  message: "",
  open: (message: string): void => {
    processing(); // オーバレイを表示
    errorDialog.message = message;
    errorDialog.show = true;
  },
  close: (): void => {
    processend(); // オーバレイを非表示
    errorDialog.show = false;
    errorDialog.message = "";
    if (sessionErr.value) {
      window.location.replace("/cms/login");
    }
  },
});

// ----- Functions -----------------------------------------------
// アコーデイオン高さチェック
const checkTagListHeight = (articleId: string | number): boolean => {
  const tagList = tagListRefs[articleId];
  if (tagList) {
    // total height ul (diseases and tags)
    const totalHeight = tagList.scrollHeight;
    return totalHeight > 135;
  }
  return false;
};

//トグルボタンの状態
const toggleExpand = (articleId: string | number) => {
  if (expandedItems[articleId]) {
    expandedItems[articleId] = false;
  } else {
    expandedItems[articleId] = true;
  }
};

// 記事詳細取得（記事orお知らせ）
const fetchContentDetail = async () => {
  await content
    .getContentDetail(articleId.value)
    .then(([model, _response, err]) => {
      const status = err?.error?.response?.status;
      if (!err) {
        contentDetail.value = model.attributes?.result || {};
      } else if (status === 404) {
        window.location.href = "/404";
      } else {
        // セッションエラー
        if (status === 408) {
          const decodedMessage = decodeURIComponent(
            err.error?.response?.data?.message
          );
          sessionErr.value = true;
          errorDialog.open(decodedMessage);
        }
        return;
      }
    });
};

// 関連記事一覧取得（記事のみ）
const fetchRelatedArticles = async () => {
  await content
    .searchArticles(page, size, contentCond.value)
    .then(([model, _response, err]) => {
      if (!err) {
        relatedContents.value = model.attributes || [];
      }
    });
};

// フォロー登録更新
const updateUserAuthorFollows = async (posterId: number) => {
  await userAuthorFollow
    .updateUserAuthorFollows(posterId)
    .then(([model, _response, err]) => {
      if (!err) {
        const result = model.attributes?.result;
        if (contentDetail.value) {
          contentDetail.value.isFollowed = result;
        }
      } else {
        // セッションエラー
        const status = err.error?.response?.status;
        if (status === 408 || status === 403) {
          const decodedMessage = decodeURIComponent(
            err.error?.response?.data?.message
          );
          sessionErr.value = true;
          errorDialog.open(decodedMessage);
        }
        return;
      }
    });
};

// 記事いいね情報更新
const updateUserArticleLikes = async (articleId: number, event: Event) => {
  const target = event.target as HTMLInputElement;

  await userArticleLike
    .updateUserArticleLikes(articleId, !target.checked)
    .then(([model, _response, err]) => {
      if (err) {
        // セッションエラー
        const status = err.error?.response?.status;
        if (status === 408 || status === 403) {
          const decodedMessage = decodeURIComponent(
            err.error?.response?.data?.message
          );
          sessionErr.value = true;
          errorDialog.open(decodedMessage);
        }
        return;
      } else {
        const likeCount = model.attributes?.result;

        if (
          contentDetail.value &&
          contentDetail.value.articleId === articleId
        ) {
          contentDetail.value.isLiked = !contentDetail.value.isLiked;
          contentDetail.value.likeCount = likeCount;
        }
        // 関連記事のいいね状態も更新
        relatedContents.value = relatedContents.value.map((article) => {
          if (article.articleId === articleId) {
            return {
              ...article,
              isLiked: !article.isLiked,
              likeCount: likeCount,
            };
          }
          return article;
        });
      }
    });
};

// 記事お気に入り更新
const updateUserArticleFavorites = async (articleId: number, event: Event) => {
  const target = event.target as HTMLInputElement;

  await userArticleFavorite
    .updateUserArticleFavorites(articleId)
    .then(([model, _response, err]) => {
      if (err) {
        target.checked = !target.checked;
        // セッションエラー
        const status = err.error?.response?.status;
        if (status === 408 || status === 403) {
          const decodedMessage = decodeURIComponent(
            err.error?.response?.data?.message
          );
          sessionErr.value = true;
          errorDialog.open(decodedMessage);
        }
        return;
      } else {
        const result = model.attributes?.result;
        target.checked = result;

        if (
          contentDetail.value &&
          contentDetail.value.articleId === articleId
        ) {
          contentDetail.value.isFavorite = result;
        }
        // 関連記事のお気に入り状態も更新
        relatedContents.value = relatedContents.value.map((article) => {
          if (article.articleId === articleId) {
            return { ...article, isFavorite: result };
          }
          return article;
        });
      }
    });
};

// 記事一覧ページへ遷移
const goToArticlePage = (cond?: ArticleQueryCond) => {
  router.push({
    name: "article",
    query: {
      cond: encodeURIComponent(JSON.stringify(cond)),
    },
  });
};

// 記事一覧ページへ遷移
const goToArticleSearchPage = (cond?: ArticleQueryCond) => {
  router.push({
    name: "article/search",
    query: {
      cond: encodeURIComponent(JSON.stringify(cond)),
    },
  });
};

// 記事詳細ページへ遷移
const goToArticleDetailPage = (newArticleId: number) => {
  if (!newArticleId) return;

  // 同じルートのため、記事IDを更新して強制的に再レンダリング
  router.replace({
    name: "article/detail",
    params: { articleId: newArticleId },
  });

  articleId.value = newArticleId;
  fetchContentDetail();
  fetchRelatedArticles();
};

// タイトルを38文字以内に…で切り捨てる
const truncateTitle = (title: string): string => {
  if (!title) return "";

  if (title.length > 38) {
    return title.slice(0, 37) + "…";
  }

  return title;
};

const markNoticeAsRead = async () => {
  const noticeListModel = new NoticeList({});
  await noticeListModel
    .readNotice(articleId.value)
    .then(([model, _response, err]) => {
      const status = err?.error?.response?.status;
      if (err) {
        // セッションエラー
        if (status === 408) {
          const decodedMessage = decodeURIComponent(
            err.error?.response?.data?.message
          );
          sessionErr.value = true;
          errorDialog.open(decodedMessage);
        }
        return;
      }
    });
};

// ---- Vue lifeCycle ----------------------------------------------
onMounted(async () => {
  await fetchContentDetail();
  if (contentDetail.value?.contentType === 2) await markNoticeAsRead();
  document.title = contentDetail.value?.title as string;
  await fetchRelatedArticles();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", { id: componentId }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(Header, {
          "active-menu": isNotice.value ? '' : activeMenu
        }, null, 8, ["active-menu"]),
        _createElementVNode("main", null, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: "content-back-button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back()))
            }, [
              _cache[13] || (_cache[13] = _createElementVNode("img", { src: "/server/necs/images/arrow-right_icon.png" }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("contentdetail_msg_goBack")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(contentDetail.value?.title), 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(contentDetail.value?.dateFirstPublished), 1),
            (contentDetail.value?.contentType !== 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", {
                      class: "content-writer",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (
                  goToArticleSearchPage({
                    posterIds: contentDetail.value?.poster.adminId
                      ? [contentDetail.value.poster.adminId]
                      : [],
                  })
                ))
                    }, [
                      _cache[14] || (_cache[14] = _createElementVNode("img", { src: "/server/necs/images/writer-img.png" }, null, -1)),
                      _createElementVNode("span", null, _toDisplayString(contentDetail.value?.poster.nickname), 1)
                    ]),
                    (
                  !contentDetail.value?.isFollowed && contentDetail.value?.contentType !== 2
                )
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "content-follow-button",
                          onClick: _cache[2] || (_cache[2] = 
                  (e) =>
                    contentDetail.value?.poster.adminId !== undefined &&
                    updateUserAuthorFollows(contentDetail.value?.poster.adminId)
                )
                        }, [
                          _cache[15] || (_cache[15] = _createElementVNode("img", { src: "/server/necs/images/article_add_icon_40.png" }, null, -1)),
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t("contentdetail_button_follow")), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (contentDetail.value?.isFollowed)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "content-following-button",
                          onClick: _cache[3] || (_cache[3] = 
                  (e) =>
                    contentDetail.value?.poster.adminId !== undefined &&
                    updateUserAuthorFollows(contentDetail.value?.poster.adminId)
                )
                        }, [
                          _cache[16] || (_cache[16] = _createElementVNode("img", { src: "/server/necs/images/following.png" }, null, -1)),
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t("contentdetail_button_following")), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("input", {
                        id: "like",
                        type: "checkbox",
                        class: "writer-like",
                        checked: contentDetail.value?.isLiked,
                        onChange: _cache[4] || (_cache[4] = 
                    (e) =>
                      contentDetail.value?.articleId !== undefined &&
                      updateUserArticleLikes(contentDetail.value.articleId, e)
                  )
                      }, null, 40, _hoisted_10),
                      _cache[17] || (_cache[17] = _createElementVNode("label", {
                        for: "like",
                        class: "like-icon detail-icon"
                      }, null, -1)),
                      _withDirectives(_createElementVNode("p", null, _toDisplayString(_ctx.$t("contentdetail_button_like")), 513), [
                        [_vShow, 
                    contentDetail.value?.articleId !== undefined &&
                    contentDetail.value.likeCount === 0
                  ]
                      ]),
                      _withDirectives(_createElementVNode("p", null, _toDisplayString(contentDetail.value?.likeCount), 513), [
                        [_vShow, 
                    contentDetail.value?.articleId !== undefined &&
                    contentDetail.value.likeCount > 0
                  ]
                      ])
                    ]),
                    _createElementVNode("input", {
                      id: "follow",
                      type: "checkbox",
                      class: "follow-button",
                      checked: contentDetail.value?.isFavorite,
                      onChange: _cache[5] || (_cache[5] = 
                  (e) =>
                    contentDetail.value?.articleId !== undefined &&
                    updateUserArticleFavorites(contentDetail.value.articleId, e)
                )
                    }, null, 40, _hoisted_11),
                    _cache[18] || (_cache[18] = _createElementVNode("label", {
                      for: "follow",
                      class: "follow-button-icon detail-icon"
                    }, null, -1))
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "content-article",
              id: "html",
              innerHTML: contentDetail.value?.html
            }, null, 8, _hoisted_12),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("ul", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contentDetail.value?.diseases, (disease, i) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "cotent-tag-item tag-disease",
                    key: i,
                    onClick: ($event: any) => (
                  goToArticleSearchPage({ diseaseCodes: [disease.diseaseCode] })
                )
                  }, _toDisplayString(disease.diseaseName), 9, _hoisted_15))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contentDetail.value?.tags, (tag, i) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "cotent-tag-item tag-interest",
                    key: i,
                    onClick: ($event: any) => (goToArticleSearchPage({ tagIds: [tag.tagId] }))
                  }, _toDisplayString(tag.tagName), 9, _hoisted_16))
                }), 128))
              ]),
              (contentDetail.value?.contentType !== 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("input", {
                        id: "like",
                        type: "checkbox",
                        class: "writer-like",
                        checked: contentDetail.value?.isLiked,
                        onChange: _cache[6] || (_cache[6] = 
                    (e) =>
                      contentDetail.value?.articleId !== undefined &&
                      updateUserArticleLikes(contentDetail.value.articleId, e)
                  )
                      }, null, 40, _hoisted_19),
                      _cache[19] || (_cache[19] = _createElementVNode("label", {
                        for: "like",
                        class: "like-icon detail-icon"
                      }, null, -1)),
                      _withDirectives(_createElementVNode("p", null, _toDisplayString(_ctx.$t("contentdetail_button_like")), 513), [
                        [_vShow, 
                    contentDetail.value?.articleId !== undefined &&
                    contentDetail.value.likeCount === 0
                  ]
                      ]),
                      _withDirectives(_createElementVNode("p", null, _toDisplayString(contentDetail.value?.likeCount), 513), [
                        [_vShow, 
                    contentDetail.value?.articleId !== undefined &&
                    contentDetail.value.likeCount > 0
                  ]
                      ])
                    ]),
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "follow-button",
                      checked: contentDetail.value?.isFavorite,
                      onChange: _cache[7] || (_cache[7] = 
                  (e) =>
                    contentDetail.value?.articleId !== undefined &&
                    updateUserArticleFavorites(contentDetail.value.articleId, e)
                )
                    }, null, 40, _hoisted_20),
                    _cache[20] || (_cache[20] = _createElementVNode("label", {
                      for: "follow",
                      class: "follow-button-icon detail-icon"
                    }, null, -1))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          (contentDetail.value?.contentType !== 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t("contentdetail_msg_checkArticleByFollow")), 1),
                _createElementVNode("div", _hoisted_23, [
                  (contentDetail.value?.poster.adminId !== undefined)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "content-writer",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (
                goToArticleSearchPage({
                  posterIds: [contentDetail.value.poster.adminId],
                })
              ))
                      }, [
                        _cache[21] || (_cache[21] = _createElementVNode("img", { src: "/server/necs/images/writer-img.png" }, null, -1)),
                        _createElementVNode("span", null, _toDisplayString(contentDetail.value?.poster.nickname), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (!contentDetail.value?.isFollowed)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "content-follow-button",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (
                contentDetail.value?.poster.adminId !== undefined &&
                  updateUserAuthorFollows(contentDetail.value.poster.adminId)
              ))
                      }, [
                        _cache[22] || (_cache[22] = _createElementVNode("img", { src: "/server/necs/images/article_add_icon_40.png" }, null, -1)),
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("contentdetail_button_follow")), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (contentDetail.value?.isFollowed)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        class: "content-following-button",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (
                contentDetail.value?.poster.adminId !== undefined &&
                  updateUserAuthorFollows(contentDetail.value.poster.adminId)
              ))
                      }, [
                        _cache[23] || (_cache[23] = _createElementVNode("img", { src: "/server/necs/images/following.png" }, null, -1)),
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("contentdetail_button_following")), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (relatedContents.value.length > 1)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_24, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(relatedContents.value, (article, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: article.articleId
                        }, [
                          (index < 3)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_25, [
                                _createElementVNode("div", {
                                  class: "sp-wrapper",
                                  onClick: ($event: any) => (goToArticleDetailPage(article.articleId))
                                }, [
                                  _createElementVNode("img", {
                                    class: "content-item-img",
                                    src: article.coverPhotoUrl,
                                    alt: _ctx.$t('contentdetail_alt_coverImage')
                                  }, null, 8, _hoisted_27),
                                  _createElementVNode("div", _hoisted_28, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["content-item-new", { none: !article.isNew }])
                                    }, _toDisplayString(article.isNew ? _ctx.$t("article_new") : ""), 3),
                                    _createElementVNode("div", _hoisted_29, _toDisplayString(truncateTitle(article.title)), 1)
                                  ])
                                ], 8, _hoisted_26),
                                _createElementVNode("div", _hoisted_30, [
                                  _createElementVNode("ul", {
                                    class: _normalizeClass(["content-item-tags", {
                      heightExpanded: expandedItems[article.articleId],
                    }]),
                                    ref_for: true,
                                    ref: (el) => (tagListRefs[article.articleId] = el)
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(article.diseases, (disease) => {
                                      return (_openBlock(), _createElementBlock("li", {
                                        class: "tag-item tag-disease",
                                        key: disease.diseaseCode,
                                        onClick: ($event: any) => (
                        goToArticleSearchPage({
                          diseaseCodes: [disease.diseaseCode],
                        })
                      )
                                      }, _toDisplayString(disease.diseaseName), 9, _hoisted_31))
                                    }), 128)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(article.tags, (tag, tIdx) => {
                                      return (_openBlock(), _createElementBlock("li", {
                                        class: "tag-item tag-interest",
                                        key: tIdx,
                                        onClick: ($event: any) => (goToArticleSearchPage({ tagIds: [tag.tagId] }))
                                      }, _toDisplayString(tag.tagName), 9, _hoisted_32))
                                    }), 128))
                                  ], 2),
                                  (checkTagListHeight(article.articleId))
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        (!expandedItems[article.articleId])
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 0,
                                              class: "contents-height-all",
                                              onClick: ($event: any) => (toggleExpand(article.articleId))
                                            }, [
                                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("article_tab_recommend_search_show")), 1),
                                              _cache[24] || (_cache[24] = _createElementVNode("img", {
                                                src: "/server/necs/images/arrow-right_icon.png",
                                                alt: "Show more"
                                              }, null, -1))
                                            ], 8, _hoisted_33))
                                          : _createCommentVNode("", true),
                                        (expandedItems[article.articleId])
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 1,
                                              class: "contents-height-hide",
                                              onClick: ($event: any) => (toggleExpand(article.articleId))
                                            }, [
                                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("article_tab_recommend_search_hidden")), 1),
                                              _cache[25] || (_cache[25] = _createElementVNode("img", {
                                                src: "/server/necs/images/arrow-right_icon.png",
                                                alt: "Show less"
                                              }, null, -1))
                                            ], 8, _hoisted_34))
                                          : _createCommentVNode("", true)
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_35, [
                                  _createElementVNode("div", _hoisted_36, _toDisplayString(article.dateFirstPublished), 1),
                                  _createElementVNode("div", _hoisted_37, [
                                    _createElementVNode("div", {
                                      class: "writer-name",
                                      onClick: ($event: any) => (
                        goToArticleSearchPage({
                          posterIds: [article.poster.adminId],
                        })
                      )
                                    }, [
                                      _createTextVNode(_toDisplayString(_ctx.$t("home_msg_author")) + " ", 1),
                                      _createElementVNode("span", _hoisted_39, _toDisplayString(article.poster.nickname), 1)
                                    ], 8, _hoisted_38),
                                    _createElementVNode("div", _hoisted_40, [
                                      _createElementVNode("input", {
                                        type: "checkbox",
                                        class: "writer-like",
                                        id: `like-toggle${index}`,
                                        checked: article.isLiked,
                                        onChange: 
                          (e) => updateUserArticleLikes(article.articleId, e)
                        
                                      }, null, 40, _hoisted_41),
                                      _createElementVNode("label", {
                                        for: `like-toggle${index}`,
                                        class: "like-icon"
                                      }, null, 8, _hoisted_42),
                                      _withDirectives(_createElementVNode("p", null, _toDisplayString(_ctx.$t("contentdetail_button_like")), 513), [
                                        [_vShow, article.likeCount === 0]
                                      ]),
                                      _withDirectives(_createElementVNode("p", null, _toDisplayString(article.likeCount), 513), [
                                        [_vShow, article.likeCount > 0]
                                      ])
                                    ]),
                                    _createElementVNode("input", {
                                      type: "checkbox",
                                      class: "writer-follow",
                                      id: `follow-toggle${index}`,
                                      checked: article.isFavorite,
                                      onChange: 
                        (e) =>
                          article.articleId !== undefined &&
                          updateUserArticleFavorites(article.articleId, e)
                      
                                    }, null, 40, _hoisted_43),
                                    _createElementVNode("label", {
                                      for: `follow-toggle${index}`,
                                      class: "follow-icon"
                                    }, null, 8, _hoisted_44)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (relatedContents.value.length >= 4)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "contents-list-button",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (
                goToArticleSearchPage({
                  posterIds: contentDetail.value?.poster.adminId
                    ? [contentDetail.value.poster.adminId]
                    : [],
                })
              ))
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("contentdetail_button_checkMoreAuthorsArticles")), 1),
                        _cache[26] || (_cache[26] = _createElementVNode("img", { src: "/server/necs/images/arrow-right_icon.png" }, null, -1))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (contentDetail.value?.contentType !== 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.$t("contentdetail_msg_pickUpRelationInfo")), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "contents-recs-button",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (goToArticlePage()))
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("contentdetail_button_checkRecommendedArticles")), 1),
                  _cache[27] || (_cache[27] = _createElementVNode("img", { src: "/server/necs/images/arrow-right_icon.png" }, null, -1))
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(Footer, {
          "scroll-target": componentId,
          "active-menu": isNotice.value ? '' : activeMenu
        }, null, 8, ["active-menu"])
      ])
    ]),
    (_unref(errorDialog).show)
      ? (_openBlock(), _createBlock(ErrorDialog, _mergeProps({ key: 0 }, _unref(errorDialog), {
          onOk: _unref(errorDialog).close,
          onCancel: _unref(errorDialog).close
        }), null, 16, ["onOk", "onCancel"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})